import { useState, useMemo, useContext } from "react";
import { useLocation } from "react-router-dom";
import MessagesSection from "./MessagesSection";
import MessageDetail from "./MessageDetail";
import Stack from "../../shared/layouts/Stack";
import Header from "../../shared/Header";
import axios from "axios";
import { useQuery } from "react-query";
import MessagebarContext from "../../../context/MessagebarContext";
import Loader from "../../shared/Loader";
import BackButton from "../../shared/BackButton";
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const MessagesPage = () => {
  const { state } = useLocation();
  const [viewMessageId, setViewMessageId] = useState(state?.id || null);

  const { setAlertMessage } = useContext(MessagebarContext);
  const { t } = useTranslation();

  const { isLoading, data: messages = [] } = useQuery(
    "messages",
    async () =>
      await axios("/messages/data")
        .then(({ data }) => data.messages)
        .catch(() => setAlertMessage())
  );

  const message = useMemo(
    () =>
      messages?.find((m) => m.organization_message_uuid === viewMessageId) ||
      {},
    [viewMessageId, messages]
  );

  const { MessageIcon } = useIconLibrary();

  return (
    <>
      {isLoading && <Loader />}
      <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
        {viewMessageId !== null && (
          <BackButton onClick={() => setViewMessageId(null)}>
            {t('Terug naar overzicht')}
          </BackButton>
        )}
        <Header
          title={t("Berichten")}
          icon={<MessageIcon height="2rem" width="2rem" />}
          variant="page"
        />
        {viewMessageId !== null ? (
          <MessageDetail {...message} />
        ) : (
          <MessagesSection
            messages={messages}
            isLoading={isLoading}
            handleRowClick={({ original }) =>
              setViewMessageId(original.organization_message_uuid)
            }
          />
        )}
      </Stack>
    </>
  );
};

export default MessagesPage;
